import React from 'react';
import theme, { styled } from '@/styles/theme';
import SelectComponent from '@/components/SelectComponent';
import { ReactComponent as Delete } from '@/assets/images/order/delete.svg';
import useOrderResetFormViewModel from './OrderResetFormViewModel';
import { useHistory } from 'react-router-dom';

interface Props {
  onClickClose: () => void;
  orderId: number;
}

const OrderResetForm = ({ onClickClose, orderId }: Props) => {
  const viewModel = useOrderResetFormViewModel(orderId);
  const history = useHistory();

  const onSubmit = async () => {
    try {
      await viewModel.submit();
      onClickClose();
      history.replace('/requested');
    } catch (error) {
      alert((error as Error).message);
    }
  };

  return (
    <Wrapper
      onMouseMove={e => {
        e.stopPropagation();
      }}>
      <TitleRow>
        <Title>조제 접수 초기화</Title>
        <Delete style={{ cursor: 'pointer' }} onClick={onClickClose} />
      </TitleRow>
      <DescriptionRow>
        조제 접수 초기화 전,{' '}
        <DescriptionHighLight>
          환자 번호로 연락해 충분한 안내를 선행
        </DescriptionHighLight>
        해주세요.
      </DescriptionRow>
      <Col>
        <SubTitle>초기화 사유</SubTitle>
        {viewModel.options && (
          <SelectComponent
            isSearchable={false}
            selectStyle={{
              width: '100%',
              marginBottom: 6,
              borderRadius: 12,
              padding: 5,
              height: 60,
              background: theme.DF_COLOR.GRAY10,
              border: `1px solid ${theme.DF_COLOR.GRAY50}`,
              fontSize: 18
            }}
            placeholder="초기화 사유를 선택해주세요."
            indicatorStyle={{ display: 'none' }}
            options={viewModel.options}
            defaultValue={null}
            onChange={viewModel.changeReason}
          />
        )}
        {viewModel.isOutOfStockSelected() && (
          <WarningHighLight>
            조제 접수 초기화 후 꼭 조제 거절을 눌러주세요.
          </WarningHighLight>
        )}
      </Col>
      <Button onClick={onSubmit}>초기화</Button>
    </Wrapper>
  );
};

export default OrderResetForm;

const Wrapper = styled.div``;

const TitleRow = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;
const Title = styled.span`
  ${({ theme }) => theme.DF_TYPOGRAPHY.UI24SB};
`;

const DescriptionRow = styled.div`
  ${({ theme }) => theme.DF_TYPOGRAPHY.UI16R};
  color: ${({ theme }) => theme.DF_COLOR.GRAY400};
  margin-top: 12px;
  margin-bottom: 12px;
`;

const DescriptionHighLight = styled.span`
  color: ${({ theme }) => theme.DF_COLOR.PRIMARY700};
`;

const WarningHighLight = styled.span`
  color: ${({ theme }) => theme.DF_COLOR.RED700};
`;

const SubTitle = styled.div`
  ${({ theme }) => theme.DF_TYPOGRAPHY.UI14M};
  color: ${({ theme }) => theme.DF_COLOR.GRAY600};
  margin-top: 20px;
  margin-bottom: 6px;
`;

const Button = styled.div`
  border-radius: 12px;
  padding: 17px 0;
  width: 160px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background: ${({ theme }) => theme.DF_COLOR.PRIMARY500};
  color: ${({ theme }) => theme.DF_COLOR.WHITE};
  ${({ theme }) => theme.DF_TYPOGRAPHY.UI18SB};
  margin-top: 32px;
  margin-left: auto;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
`;

const Col = styled.div`
  display: flex;
  flex-direction: column;
  width: 432px;
`;
